import { useState } from "react";
import { EMPLOYEES } from "../../../../data/origami/employees";

export function EmployeeRegister({ onEmployeeSelect, onEmployeeClick }) {
  const [query, setQuery] = useState("");

  const filtered = EMPLOYEES.filter((e) => {
    const q = query.toLowerCase();
    return (
      e.id.toString().includes(q) ||
      e.nom.toLowerCase().includes(q) ||
      e.prenom.toLowerCase().includes(q)
    );
  }).sort((a, b) => {
    // ID 359 remonte toujours en premier
    if (a.id === 359) return -1;
    if (b.id === 359) return 1;
    return 0;
  });

  return (
    <div className="space-y-3 text-xs">
      <input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Rechercher par ID"
        className="w-full px-3 py-2 rounded-lg bg-black/50 border border-white/20 text-xs focus:outline-none focus:ring-2 focus:ring-indigo-500"
      />
      <div className="max-h-72 overflow-y-auto mt-2 divide-y divide-white/5 custom-scrollbar">
        {filtered.map((e) => {
          const isTarget = e.id === 359;
          return (
            <div
              key={e.id}
              className={[
                "py-2 cursor-pointer rounded-md px-2 transition-colors",
                isTarget
                  ? "bg-amber-500/10 border border-amber-400/30 hover:bg-amber-500/18 mb-1"
                  : "hover:bg-white/5",
              ].join(" ")}
              onClick={() => {
                onEmployeeSelect?.(e);
                onEmployeeClick?.(e);
              }}
            >
              <div className="flex items-center justify-between gap-2">
                <span className={["font-semibold", isTarget ? "text-amber-200" : ""].join(" ")}>
                  {e.prenom} {e.nom}
                </span>
                <span className={[
                  "text-[10px] font-mono px-1.5 py-0.5 rounded",
                  isTarget
                    ? "bg-amber-500/20 text-amber-300 border border-amber-400/40"
                    : "text-slate-500",
                ].join(" ")}>
                  ID {e.id}
                </span>
              </div>
              <div className="text-[11px] text-slate-300 mt-0.5">
                {e.poste} — {e.equipe}
              </div>
            </div>
          );
        })}

        {filtered.length === 0 && (
          <p className="text-[11px] text-slate-400 mt-2">
            Aucun résultat pour cette recherche.
          </p>
        )}
      </div>
    </div>
  );
}